import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import { useEffect, useRef, useState } from "react";

import { APButtonLink } from "./buttons/APButtonLink";

export function APShowMoreContainer({
  children,
  collapsedSize,
  open: controlledOpen,
  onToggle: controlledToggle,
}: {
  children: React.ReactNode;
  collapsedSize: number;
  open?: boolean; // optional: controlled open state
  onToggle?: () => void; // optional: controlled toggle callback
}) {
  const [internalOpen, setInternalOpen] = useState(false); // internal state for uncontrolled mode
  const [needsToggle, setNeedsToggle] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const isControlled =
    controlledOpen !== undefined && controlledToggle !== undefined;
  const open = isControlled ? controlledOpen : internalOpen;
  const toggle = () => {
    if (isControlled) {
      controlledToggle!();
    } else {
      setInternalOpen((o) => !o);
    }
  };
  useEffect(() => {
    if (contentRef.current) {
      const fullHeight = contentRef.current.scrollHeight;
      setNeedsToggle(fullHeight > collapsedSize);
    }
  }, [children, collapsedSize]);

  return (
    <>
      <Collapse
        in={!needsToggle || open}
        collapsedSize={needsToggle ? collapsedSize : "auto"}
      >
        <Box ref={contentRef}>{children}</Box>
      </Collapse>

      {needsToggle && (
        <Box mt={0.5}>
          <APButtonLink
            text={open ? "Show less" : "Show more"}
            onClick={toggle}
          />
        </Box>
      )}
    </>
  );
}
